import type { FlightPayload } from "./types";

export const TRACK_COLORS = [
  "#10b981",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#f59e0b",
  "#06b6d4",
  "#84cc16",
  "#ef4444",
] as const;

interface AdventureMapLine {
  id: string;
  color: string;
  positions: [number, number][];
}

export interface AdventureMapLines {
  flightLines: AdventureMapLine[];
  upTrackLines: AdventureMapLine[];
}

export function buildAdventureMapLines(flights: FlightPayload[]): AdventureMapLines {
  const colors = adventurePilotColors(flights);

  const flightLines: AdventureMapLine[] = [];
  const upTrackLines: AdventureMapLine[] = [];

  for (const flight of flights) {
    if (flight.json_track?.length) {
      flightLines.push({
        id: `flight-${flight.id}`,
        color: colors.get(flight.pilot_id)!,
        positions: flight.json_track.map((point) => [
          point.coordinates.lat,
          point.coordinates.lon,
        ] as [number, number]),
      });
    }

    if (flight.json_up_track?.length) {
      upTrackLines.push({
        id: `up-${flight.id}`,
        color: colors.get(flight.pilot_id)!,
        positions: flight.json_up_track.map((point) => [
          point.coordinates.lat,
          point.coordinates.lon,
        ] as [number, number]),
      });
    }
  }

  return { flightLines, upTrackLines };
}

export function adventurePilotColors(flights: FlightPayload[]): Map<number, string> {
  const ids = [...new Set(flights.map(flight => flight.pilot_id))].sort((a, b) => a - b);
  return new Map(ids.map((id, index) => [id, TRACK_COLORS[index] ?? `hsl(${(index * 137.508) % 360}, 75%, 55%)`]));
}
